import ZaiaInput from "./ZaiaInput";

export default ZaiaInput;